import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material UI
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import ReminderIcon from '@material-ui/icons/Alarm';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';

import { markCounterPartRemindersAsDoneURL, deleteCounterPartRemindersURL } from '../constants';
import { formatDateToDELocaleTime } from '../utils/utilFunctions';
import { markCounterPartRemindersAsDone, deleteCounterPartReminders } from '../reminders/api/counterPartReminderAPI';

const ReminderListItem = ({
  id,
  title,
  description,
  dueDate,
  companyId,
  counterPart,
  isRead,
  onIsReadButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  errorHandling
}) => {
  const handleMarkAsRead = useCallback(async () => {
    try {
      await markCounterPartRemindersAsDone([id]);
      onIsReadButtonClick(true);
    } catch (err) {
      errorHandling(err, markCounterPartRemindersAsDoneURL);
    }
  }, [id, onIsReadButtonClick, errorHandling]);

  const handleDelete = useCallback(async () => {
    try {
      await deleteCounterPartReminders([id]);
      onDeleteButtonClick(true);
    } catch (err) {
      errorHandling(err, deleteCounterPartRemindersURL);
    }
  }, [id, onDeleteButtonClick, errorHandling]);

  const handleEdit = useCallback(() => {
    onEditButtonClick({
      id,
      companyId,
      counterPartId: counterPart.id,
      note: description,
      triggerDate: dueDate,
      notificationId: id
    });
  }, [id, companyId, counterPart, description, dueDate, onEditButtonClick]);

  return (
    <ListItem
      button
      style={isRead ? { backgroundColor: '#e8e8e8' } : {}}
      component={Link}
      to={`/companies?id=${companyId}&cpid=${counterPart.id}`}
    >
      <ListItemAvatar>
        <Avatar>
          <ReminderIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <span>
            <span style={{ fontWeight: '500' }}>{title}: </span>
            {counterPart && `Ansprechpartner: ${counterPart.firstName} ${counterPart.lastName} `}
            {description.length > 0 && `Beschreibung: ${description}`}
          </span>
        }
        secondary={dueDate ? formatDateToDELocaleTime(new Date(dueDate)) : ''}
      />
      <ListItemSecondaryAction>
        <IconButton aria-label="edit" onClick={handleEdit}>
          <EditIcon />
        </IconButton>
        <IconButton aria-label="mark_unread" onClick={handleMarkAsRead}>
          {isRead ? <DoneIcon color="primary" /> : <DoneIcon />}
        </IconButton>
        <IconButton aria-label="Delete" onClick={handleDelete}>
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

ReminderListItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dueDate: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  counterPart: PropTypes.object.isRequired,
  isRead: PropTypes.bool.isRequired,
  onIsReadButtonClick: PropTypes.func.isRequired,
  onDeleteButtonClick: PropTypes.func.isRequired,
  onEditButtonClick: PropTypes.func.isRequired,
  errorHandling: PropTypes.func.isRequired
};

export default ReminderListItem;
